// @flow

/**
 * List of barcode values that should be excluded from processing.
 * These barcodes are ignored when scanned and an error message is shown to the user.
 */
export const EXCLUDED_BARCODE_VALUES = [
  "42019154",
  "4201915400",
  "420191540000",
  "4201915401",
  "42019154101",
  "420191541011"
];
